export const PaperIcon = (): JSX.Element => {
  return (
    <svg width="24" height="24" fill="none">
      <path
        d="M18.535 21.815H5.475c-.68 0-1.24-.56-1.24-1.24V8.035c0-.19.04-.37.12-.54a.81.81 0 0 1 .73-.45h4v-4.01c0-.34.21-.64.52-.76.16-.06.31-.09.47-.09h8.46c.68 0 1.23.56 1.23 1.24v17.14c0 .68-.55 1.24-1.23 1.24v.01Zm-12.67-1.62h12.28V3.815h-7.43v3.61c0 .68-.56 1.24-1.24 1.24h-3.61v11.53Z"
        fill="#302C41"
      />
      <path
        d="M9.905 3.045v4.39c0 .24-.19.43-.43.43h-4.38s.05-.09.09-.12l4.61-4.61s.08-.07.12-.09h-.01Z"
        fill="#302C41"
      />
      <path
        d="M9.475 8.675h-4.38a.82.82 0 0 1-.66-.34.827.827 0 0 1-.11-.73c.07-.2.19-.34.27-.43l4.61-4.61c.11-.11.22-.19.35-.25.25-.12.55-.1.78.05.24.15.38.41.38.69v4.39c0 .68-.56 1.24-1.24 1.24v-.01Zm-2.46-1.63h2.07v-2.07l-2.07 2.07Z"
        fill="#302C41"
      />
      <path
        d="M5.085 8.675h-.04c-.45 0-.81-.36-.81-.81 0-.45.36-.81.81-.81.45 0 .83.36.83.81 0 .45-.34.81-.79.81ZM9.905 3.835c-.45 0-.81-.35-.81-.79v-.04c0-.45.36-.81.81-.81.45 0 .81.36.81.81 0 .45-.36.83-.81.83ZM16.515 17.705h-9.02c-.45 0-.81-.36-.81-.81 0-.45.36-.81.81-.81h9.02c.45 0 .81.36.81.81 0 .45-.36.81-.81.81ZM16.515 12.825h-9.02c-.45 0-.81-.36-.81-.81 0-.45.36-.81.81-.81h9.02c.45 0 .81.36.81.81 0 .45-.36.81-.81.81ZM16.515 7.935h-4.51c-.45 0-.81-.36-.81-.81 0-.45.36-.81.81-.81h4.51c.45 0 .81.36.81.81 0 .45-.36.81-.81.81Z"
        fill="#302C41"
      />
    </svg>
  )
}
